/**
 * Converts an ISO date string to a formatted time string
 * @param {string} isoDate - ISO date string to format
 * @param {boolean} [showTimeZone=false] - Whether to show the timezone
 * @returns {string} Formatted time string with hours, minutes, seconds, and milliseconds
 */
const convert = (isoDate, showTimeZone = false) => {
    const date = new Date(isoDate);

    // Format time components with hour12
    const timePart = date.toLocaleTimeString(undefined, {
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true
    });

    // Get milliseconds
    const milliseconds = Math.floor(date.getMilliseconds() / 100);

    // Get timezone abbreviation (e.g., EDT) if requested
    let timeZone = "";
    if (showTimeZone) {
        const timeZoneParts = date.toLocaleTimeString(undefined, {
            timeZoneName: "short",
            hour: "numeric",
            hour12: true
        }).split(" ");
        timeZone = ` (${timeZoneParts[timeZoneParts.length - 1]})`;
    }

    // Inject milliseconds before AM/PM
    const [timeWithoutPeriod, period] = timePart.split(/ (AM|PM)/);
    const fullTime = `${timeWithoutPeriod}.${milliseconds} ${period}${timeZone}`;

    return fullTime;
};

export default convert;